import { usePathname } from 'next/navigation'

export function Assignment() {
  const pathname = usePathname()

  return (
    <section>
      <div className="mx-auto w-full px-6 xl:px-0 pb-8 lg:pb-16 max-w-[960px]">
        <div className="relative">
          <h2 className="text-lg lg:text-4xl font-bold text-center pt-10 lg:pt-20 relative z-10">
            LAWGUEならこれらの課題
            <br className="block lg:hidden" />
            解決できます
          </h2>
          <span className="absolute inset-0 flex items-center justify-center z-[-1]">
            <img
              decoding="async"
              src="/images/img_title_pickup.svg"
              alt=""
              className="w-full"
            />
          </span>
        </div>

        {pathname === '/contract/' && (
          <>
            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    「あの」契約書、「あの」文例をAIが発見
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      01
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  あいまいな記憶からはなかなかたどり着けない
                  <br className="hidden lg:block" />
                  参考にしたい契約書や文例。
                  <br />
                  LAWGUEならレビューで参考にすべき
                  <br className="hidden lg:block" />
                  契約書や文例、さらには抜けている条項まで
                  <br className="hidden lg:block" />
                  AIが自動で見つけてくれます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution01.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row-reverse justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    契約経緯の社内ナレッジを
                    <br className="block lg:hidden" />
                    逃さず記憶
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      02
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  メール、文書内のコメント、バージョン履歴、
                  <br className="hidden lg:block" />
                  担当者の頭の中、社内のナレッジを探すのは大変です。
                  <br />
                  LAWGUE上でコメントのやりとりや編集作業を
                  <br className="hidden lg:block" />
                  一元化することで、一言一句逃さず
                  <br className="hidden lg:block" />
                  いつでもナレッジを見つけることが可能です。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution02.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20 mb-0 lg:mb-16">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    細かいチェックはAIにおまかせ
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      03
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  参照番号、インデントのズレ、表記ゆれの確認、
                  <br className="hidden lg:block" />
                  最終チェックには意外と時間がかかるものです。
                  <br />
                  一度LAWGUEに契約書をアップロードしてしまえば、
                  <br className="hidden lg:block" />
                  条ズレやインデントを気にせず編集でき、
                  <br className="hidden lg:block" />
                  表記揺れも一瞬で見つけることができます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution03.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>
          </>
        )}
        {pathname === '/law/' && (
          <>
            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    法改正に連動したメンテナンス
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      01
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  法改正への対応では、多くのリサーチ時間や
                  <br className="hidden lg:block" />
                  網羅的に反映できているかの不安が伴います。
                  <br />
                  LAWGUEなら法改正の影響がある文書を自動で特定して
                  <br className="hidden lg:block" />
                  ワンクリックで改正内容を確認できるので
                  <br className="hidden lg:block" />
                  リサーチ時間を短縮、改正の見落としを防止します。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution10.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row-reverse justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    社内規程の電子化と管理
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      02
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  最新版だけでなく、過去のバージョンも必要な
                  <br className="hidden lg:block" />
                  社内規程の管理には煩雑な作業が伴います。
                  <br />
                  AIが自動的に必要な規程や条項を探し出してくれる
                  <br className="hidden lg:block" />
                  LAWGUE上で社内規程をデータベース化することで
                  <br className="hidden lg:block" />
                  改定履歴や変更前後の比較を簡単に行うことができます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution11.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    様々なフォーマットに対応
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      03
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  社内外の公開に合わせて、様々なフォーマットへの
                  <br className="hidden lg:block" />
                  変換は意外と時間がかかってしまうものです。
                  <br />
                  LAWGUEで作成した文書は、WordやPDFにいつでも
                  <br className="hidden lg:block" />
                  変換可能で、作成が大変な改定前後の新旧対照表も
                  <br className="hidden lg:block" />
                  ワンクリックで作成することができます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution12.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>
          </>
        )}
        {pathname === '/regulation/' && (
          <>
            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    新規程はワンクリックで作成
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      01
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  新しい規程を作成するには事前の情報収集や
                  <br className="hidden lg:block" />
                  社内の状況に合わせた内容の検討などに、
                  <br className="hidden lg:block" />
                  多くの時間を費やします。
                  <br />
                  LAWGUEなら解説がついた豊富な雛形集で
                  <br className="hidden lg:block" />
                  内容の理解から新しい規程の作成まで、誰でも簡単に行えます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution04.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row-reverse justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    最新の法令にも対応
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      02
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  法令の改正があった際には、改正内容の把握、
                  <br className="hidden lg:block" />
                  自社規程への影響の確認や規程文言の修正などの
                  <br className="hidden lg:block" />
                  時間のかかる様々な作業が伴います。 <br />
                  最新法令に合わせた解説付きの雛形搭載の
                  <br className="hidden lg:block" />
                  LAWGUEなら効率的に校正が可能です。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution05.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    改訂作業を大幅に効率化
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      03
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  規程の校正が完了しても、最新版の管理、
                  <br className="hidden lg:block" />
                  新旧対照表の作成など、改訂に伴う作業は
                  <br className="hidden lg:block" />
                  まだまだ沢山あります。 <br />
                  LAWGUEを使えば、煩わしい版管理から解放され
                  <br className="hidden lg:block" />
                  新旧対照表もワンクリックで出力できます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution06.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>
          </>
        )}
        {pathname === '/translation/' && (
          <>
            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    ワンクリックで翻訳結果を表示
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      01
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  英文契約書では契約の内容や交渉ポイントを
                  <br className="hidden lg:block" />
                  把握するだけでも日本語の契約書に比べて
                  <br className="hidden lg:block" />
                  時間がかかってしまいます。
                  <br />
                  LAWGUEならこれを瞬時に翻訳できるので
                  <br className="hidden lg:block" />
                  全体像の把握を大幅に効率化できます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution07.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row-reverse justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    正確な翻訳を実現
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      02
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  専門用語や契約書独自の表現がうまく翻訳されず
                  <br className="hidden lg:block" />
                  AI翻訳の活用を諦めてしまってはいないでしょうか。
                  <br />
                  契約書に特化した翻訳エンジンや
                  <br className="hidden lg:block" />
                  辞書登録機能を利用することで
                  <br className="hidden lg:block" />
                  最適な翻訳を実現することが可能です。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution08.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between mt-10 lg:mt-20">
              <div className="w-full lg:w-[47.5%]">
                <div className="flex flex-col-reverse items-start">
                  <h3 className="text-left text-lg lg:text-4xl text-textblack font-bold">
                    過去の言い回しはAIが発見
                  </h3>
                  <p className="text-4xl font-bold leading-none font-robot">
                    <span className="relative inline-block before:absolute before:bg-[#E7DBCC] before:top-1/2 before:left-0 before:w-[110px] before:h-[30px] before:-z-10 before:-translate-y-1/2">
                      03
                    </span>
                  </p>
                </div>
                <p className="text-left text-sm lg:text-base leading-relaxed mt-3">
                  英文契約書でも、日本語同様に英文ならではの
                  <br className="hidden lg:block" />
                  独特の言い回しが 数多く存在します。
                  <br />
                  LAWGUEでは条項単位で翻訳結果が保存されるので
                  <br className="hidden lg:block" />
                  過去契約書の「あの」使いたい言い回しを
                  <br className="hidden lg:block" />
                  AIが自動的に見つけてくれます。
                </p>
              </div>
              <div className="w-full mt-4 lg:mt-0 lg:w-[47.5%]">
                <img
                  decoding="async"
                  src="/images/solution/img_task_solution09.webp"
                  alt=""
                  className="w-full"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
